import type { ReactNode } from 'react'

function escapeRegExp(s: string): string {
  return s.replace(/[.*+?^${}()|[\]\\]/g, '\\$&')
}

export function buildKeywordPattern(keywords: string[]): RegExp | null {
  if (!keywords.length) return null
  const sorted = [...keywords].sort((a, b) => b.length - a.length)
  const escaped = sorted.map(escapeRegExp)
  return new RegExp(`(${escaped.join('|')})`, 'giu')
}

export function applyHighlight(content: string, pattern: RegExp | null): ReactNode[] {
  if (!pattern) return [content]
  pattern.lastIndex = 0
  const parts = content.split(pattern)

  return parts.map((part, i) =>
    i % 2 === 1 ? (
      <mark
        key={i}
        className="rounded-sm bg-highlight-surface px-0.5 text-highlight-text"
      >
        {part}
      </mark>
    ) : (
      part
    ),
  )
}

export function highlightKeywords(content: string, keywords: string[]): ReactNode[] {
  return applyHighlight(content, buildKeywordPattern(keywords))
}
